
<div class="gauge-responsive-container">
  <highcharts-chart *ngIf="IsInit || true"
          [Highcharts]="Highcharts"
          [constructorType]="constructorType"
          [options]="chartOptions"
          [callbackFunction]="chartCallback"
          [(update)]="updateFlag"
          class="{{gaugeType}}">
  </highcharts-chart>
</div>
